<!-- 单个任务卡片：标题 + 副标题（可选）+ 描述（可选）+ 按钮（支持禁用态/隐藏）+ 抽奖机会标签 -->
<script lang="ts">
  import { _ as t } from "svelte-i18n";

  let {
    title = "",
    subtitle = "",
    desc = "",
    chanceLabel = "",
    buttonLabel = "",
    showButton = true,
    disabled = false,
    onAction = undefined,
  }: {
    title: string;
    /** 标题后的小字说明（如"单项最高：1次抽奖机会"） */
    subtitle?: string;
    desc?: string;
    /** 底部标签文案（如"抽奖机会 +1"），默认使用 task_chance_label */
    chanceLabel?: string;
    buttonLabel?: string;
    /** 是否显示按钮 */
    showButton?: boolean;
    /** 按钮是否不可点击 */
    disabled?: boolean;
    onAction?: () => void;
  } = $props();
</script>

<div
  class="flex bg-bg-color-group-3 items-start justify-between rounded-[8px] px-[16px] py-[16px]"
>
  <div class="flex flex-col gap-[4px] flex-1 mr-[12px]">
    <span class="text-[16px] font-semibold text-text-h1"
      >{title}{#if subtitle}<span class="text-[12px] font-semibold text-text-h1"
          >{" "}（{subtitle}）</span
        >{/if}</span
    >
    {#if desc}
      <span class="text-[12px] text-text-h2 leading-[1.4]">{desc}</span>
    {/if}
    <span class="text-[14px] text-primary-color font-normal"
      >{chanceLabel || $t("task_chance_label")}</span
    >
  </div>
  {#if showButton}
    <button
      class="shrink-0 h-[32px] mt-[4px] px-[14px] flex items-center justify-center rounded-[104px] text-[14px] font-normal text-text-reverse1 {disabled
        ? 'bg-button-primary-bg-disable'
        : 'bg-primary-color'}"
      type="button"
      {disabled}
      onclick={disabled ? undefined : onAction}
    >
      {buttonLabel}
    </button>
  {/if}
</div>
